// export type TTableStructureType =
// 	| 'string'
// 	| 'text'
// 	| 'link'
// 	| 'number'
// 	| 'date'
// 	| 'datePeriod'
// 	| 'user'
// 	| 'status'
// 	| 'currency'
// 	| 'country'
// 	| 'boolean'
// 	| 'button'
// 	| 'buttons';

export enum ETableStructureType {
	STRING = 'string',
	TEXT = 'text',
	LINK = 'link',
	NUMBER = 'number',
	DATE = 'date',
	DATE_PERIOD = 'datePeriod',
	DATE_MONTH = 'dateMonth',
	STATUS = 'status',
	AMOUNT = 'amount',
	CURRENCY = 'currency',
	COUNTRY_CODE = 'countryCode',
	COUNTRY_NAME = 'countryName',
	BOOLEAN = 'boolean',
	BUTTONS = 'buttons',
	CHECKBOX = 'checkbox',
	USER = 'user',
	CUSTOM = 'custom',
}

export enum ETableStructureAlign {
	CENTER = 'center',
	LEFT = 'left',
	RIGHT = 'right',
}

export type TTableStructureFilter = string[][];
export type TTableStructureColors = string[][];

export type TTableStructure<TSelector, TItem = any> = {
	name: string;
	selector: TSelector;
	show: boolean;
	searchable?: boolean;
	sortable: boolean;
	filterable: boolean;
	filter?: TTableStructureFilter;
	colors?: TTableStructureColors;
	colSpan: number;
	type: ETableStructureType;
	align: ETableStructureAlign;
	noName?: boolean;
	buttons?: string[];
	buttonFilter?: (item: TItem) => string[];
	currency?: string | ((item: TItem) => string);
};

export type THandleAction = (id: number, typeOfDialog: string) => void;

export type TShowButtons = {
	[key: string]: boolean;
};
